import styled from 'styled-components'
import { Form } from 'semantic-ui-react'

/**
 * FormTextArea Styled Components
 * Matches original OrderEditor field styling
 */

export const StyledFormField = styled(Form.Field)`
  position: relative;
  padding: 0.5em 0;

  label {
    display: block;
    padding: 0.3em 0 0.2em 0.2em;
  }

  &.required label {
    position: relative;
    padding-left: 0.75em;

    &::before {
      color: var(--red);
      content: '* ';
      font-size: 1.4em;
      left: 0;
      position: absolute;
      top: 0.2em;
    }
  }

  /* Suppress Semantic UI's auto-asterisk on required labels so we don't
     double up with the custom ::before above. !important is required because
     Semantic UI's '.ui.form .required.field > label::after' selector outranks
     the styled-component class selector on specificity. */
  &.required label::after {
    content: none !important;
  }

  textarea:focus {
    border-color: var(--primary) !important;
  }

  &.error textarea,
  textarea.error {
    border-color: #ca0808 !important;

    &:focus {
      border-color: #ff0000 !important;
    }
  }

  textarea {
    /* Full width without relying on a .ui.form ancestor */
    width: 100%;
    padding: 0.67857143em 1em; /* Match FormInput/FormSelect padding */
    border: 1px solid rgba(34, 36, 38, 0.15); /* Match FormInput/FormSelect light border */
    resize: none;
    outline: none;

    &::placeholder {
      color: var(--textarea-placeholder-color);
    }
  }

  &.disabled textarea {
    opacity: 0.9;
    background-image: repeating-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5) 5px,
      rgba(243, 243, 243, 0.5) 5px,
      rgba(243, 243, 243, 0.5) 10px
    );
    color: #666;
  }
`

export const CharacterCount = styled.div`
  font-size: 0.85em;
  color: #999;
  margin-top: 0.25em;
`
